<div class="orders-page">
  <div *ngIf="idEvent">
    <div class="filters-row d-flex justify-content-between" *ngIf="sessions?.length > 1">
      <div class="w-100">
        <!-- <div class="container-filters"> -->
        <mat-form-field appearance="fill" class="select-filter-panel filter-sessions mat-select-session">
          <mat-select #listSessions class="text-black" panelClass="selectPanelControl" multiple
            placeholder="Seleccionar sesión/sesiones*" [(ngModel)]="selectedSession" disableOptionCentering="false"
            (ngModelChange)="changedSession=true" (closed)="updateSessionFilter()">
            <mat-option *ngFor="let session of filteredSessions" [value]="session.id">
              <span>{{(session.start_date|date:'dd/MM/yyyy - HH:mm':'+0000')}}h</span></mat-option>
          </mat-select>

          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down pointer-in"></i>
          </mat-select-trigger>
        </mat-form-field>
        <!-- </div> -->
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center gap-2">
    <div class="content-search col-12 col-md-6">
      <div class="search-container container-form d-flex align-items-center borderInput search-full"
        [class.search-event]="idEvent">
        <i class="fal fa-search search-icon pointer-in" (click)="searchOrder(searchInput.value)"></i>
        <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar pedido" [(ngModel)]="searchText"
          (input)="searchOrder(searchInput.value)">
      </div>
      <div class="btn-create btn-filter m-0" (click)="openFilters()">
        <i class="fal fa-sliders"></i>
        <p class="m-0">Filtrar</p>
      </div>
    </div>
    <button class="btn-clear-filters" *ngIf="filterActive || searchText" (click)="clearFilters()">
      <i class="fal fa-times"></i>
      <span>Quitar filtros</span>
    </button>
  </div>



  <!-- Filtros Desktop -->
  <div class="container-filters flex-row desktop-filters" *ngIf="activeFilters">
    <!-- Espacio -->
    <div *ngIf="!idEvent && placesEnabled?.length > 1">
      <mat-form-field appearance="fill" class="select-filter-panel">
        <mat-select class="text-black" panelClass="selectPanelControl" placeholder="Espacio"
          [(ngModel)]="placeFilter" disableOptionCentering="false"
          (ngModelChange)="changePlaceFilter()">
          <mat-option [value]="null">Todos los espacios</mat-option>
          <mat-option *ngFor="let place of placesEnabled" [value]="place.id">
            <span>{{place.name}}</span>
          </mat-option>
        </mat-select>
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
    </div>
    <!-- Fecha -->
    <div class="flex-column">
      <mat-form-field appearance="fill" class="select-filter-panel pointer-in"
        (click)="openDatePicker=!openDatePicker; openPriceRange=false">
        <input matInput placeholder="Fecha" class="input-date pointer-in" readonly [(ngModel)]="stringDate">
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
      <div class="padding-option">
        <app-custom-calendar-panel [datesRange]="datesRange" [openDatePicker]="openDatePicker"
          (closeEvent)="openDatePicker = false" (datesEvent)="selectDates($event)"></app-custom-calendar-panel>
      </div>
    </div>
    <!-- Rango de precios -->
    <div class="flex-column">
      <mat-form-field appearance="fill" class="select-filter-panel pointer-in">
        <input matInput placeholder="Precio del pedido" class="input-date pointer-in" readonly
          [(ngModel)]="selectedPriceRange" (click)="openPriceRange=!openPriceRange">
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
      <div class="padding-option dialog-price-range" *ngIf="openPriceRange">
        <div class="slider-filter">
          <span>Selecciona un rango de precios:</span>
          <mat-slider min="0" [max]="maxPriceEnabled" discrete="false" (change)="changeValuesPrice()">
            <input value="0" [(ngModel)]="priceFilter.min" matSliderStartThumb>
            <input [value]="maxPriceEnabled" [(ngModel)]="priceFilter.max" matSliderEndThumb>
          </mat-slider>
          <div class="d-flex justify-content-between ">
            <span>{{priceFilter.min}}€</span>
            <span>{{priceFilter.max}}€</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Estado -->
    <div>
      <mat-form-field appearance="fill" class="select-filter-panel" (click)="openPriceRange=false">
        <mat-select #selectStatus class="text-black" panelClass="selectPanelControl" placeholder="Estado" multiple
          [disabled]="loadingFilter" [(ngModel)]="statusFilter" disableOptionCentering="false"
          (ngModelChange)="changeStatus=true" (closed)="updateStatus()">
          <mat-option *ngFor="let status of statusOptions | async" [value]="status.id">
            <span>{{status.name}}</span></mat-option>
        </mat-select>
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
    </div>


    <!-- Metodo de pago -->
    <div>
      <mat-form-field appearance="fill" class="select-filter-panel" (click)="openPriceRange=false">
        <mat-select #selectPay class="text-black" panelClass="selectPanelControl" placeholder="Método de pago" multiple
          [disabled]="loadingFilter" [(ngModel)]="methodFilter" disableOptionCentering="false"
          (ngModelChange)="changeMethod=true" (closed)="updateMethod()">
          <mat-option *ngFor="let method of methodsOptions | async" [value]="method.id">
            <span>{{method.name}}</span>
          </mat-option>
        </mat-select>
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
    </div>
    <!-- Eliminar filtros -->
    <!-- <div class="btn-clear-filter m-0" (click)="clearFilters()" *ngIf="filterActive">
            <i class="fal fa-times"></i>
            <p class="m-0">Limpiar</p>
        </div> -->
  </div>
  <div class="filters-selected col-12 col-lg-6 col-xl-8 order-1 mt-3 d-lg-none">
    <div class="content-filter" *ngIf="searchText"><i class="fa-light fa-times fa-sm icon-delete pointer-in"
        (click)="deleteFilter(searchText)"></i>{{ searchText }}<i class="fa-light fa-search icon-search fa-sm"></i>
    </div>
    <div *ngFor="let filter of getFiltersActive()" class="me-2 d-inline-block">
      <div class="content-filter" *ngIf="filter.name">
        <i class="fa-light fa-times fa-xs icon-delete pointer-in" (click)="deleteFilter(filter)"></i>
        {{ filter.type != 'price' ? filter.name : (filter.min+'-'+filter.max+' €') }}
        <i *ngIf="filter.type == 'order'" class="fa-light fa-arrow-up-arrow-down icon-search fa-sm"></i>
      </div>
    </div>
  </div>
  <!-- Offcanvas Filtros Móvil -->
  <div class="filters-offcanvas" [class.show]="showMobileFilters">
    <div class="offcanvas-header">
      <h5 class="text-primary">Filtros</h5>
      <button type="button" class="btn-close" (click)="closeMobileFilters()">
        <i class="fal fa-times"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <!-- Espacio -->
      <div class="mb-3" *ngIf="!idEvent && placesEnabled?.length > 1">
        <mat-form-field appearance="fill" class="select-filter-panel">
          <mat-select class="text-black" panelClass="selectPanelControl" placeholder="Espacio"
            [(ngModel)]="placeFilter" disableOptionCentering="false"
            (ngModelChange)="changePlaceFilter()">
            <mat-option [value]="null">Todos los espacios</mat-option>
            <mat-option *ngFor="let place of placesEnabled" [value]="place.id">
              <span>{{place.name}}</span>
            </mat-option>
          </mat-select>
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down pointer-in"></i>
          </mat-select-trigger>
        </mat-form-field>
      </div>
      <!-- Fecha -->
      <div class="flex-column mb-3">
        <mat-form-field appearance="fill" class="select-filter-panel pointer-in"
          (click)="openDatePicker=!openDatePicker; openPriceRange=false">
          <input matInput placeholder="Fecha" class="input-date pointer-in" readonly [(ngModel)]="stringDate">
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down pointer-in"></i>
          </mat-select-trigger>
        </mat-form-field>
        <div class="padding-option">
          <app-custom-calendar-panel [datesRange]="datesRange" [openDatePicker]="openDatePicker"
            (closeEvent)="openDatePicker = false" (datesEvent)="selectDates($event)"></app-custom-calendar-panel>
        </div>
      </div>
      <!-- Rango de precios -->
      <div class="flex-column mb-3">
        <mat-form-field appearance="fill" class="select-filter-panel pointer-in">
          <input matInput placeholder="Precio del pedido" class="input-date pointer-in" readonly
            [(ngModel)]="selectedPriceRange" (click)="openPriceRange=!openPriceRange">
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down pointer-in"></i>
          </mat-select-trigger>
        </mat-form-field>
        <div class="padding-option dialog-price-range" *ngIf="openPriceRange">
          <div class="slider-filter">
            <span>Selecciona un rango de precios:</span>
            <mat-slider min="0" [max]="maxPriceEnabled" discrete="false" (change)="changeValuesPrice()">
              <input value="0" [(ngModel)]="priceFilter.min" matSliderStartThumb>
              <input [value]="maxPriceEnabled" [(ngModel)]="priceFilter.max" matSliderEndThumb>
            </mat-slider>
            <div class="d-flex justify-content-between ">
              <span>{{priceFilter.min}}€</span>
              <span>{{priceFilter.max}}€</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Estado -->
      <div class="mb-3">
        <mat-form-field appearance="fill" class="select-filter-panel" (click)="openPriceRange=false">
          <mat-select class="text-black" panelClass="selectPanelControl" placeholder="Estado" multiple
            [disabled]="loadingFilter" [(ngModel)]="statusFilter" disableOptionCentering="false"
            (ngModelChange)="changeStatus=true" (closed)="updateStatus()">
            <mat-option *ngFor="let status of statusOptions | async" [value]="status.id">
              <span>{{status.name}}</span></mat-option>
          </mat-select>
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down pointer-in"></i>
          </mat-select-trigger>
        </mat-form-field>
      </div>
      <!-- Método de pago -->
      <div class="mb-3">
        <mat-form-field appearance="fill" class="select-filter-panel" (click)="openPriceRange=false">
          <mat-select class="text-black" panelClass="selectPanelControl" placeholder="Método de pago" multiple
            [disabled]="loadingFilter" [(ngModel)]="methodFilter" disableOptionCentering="false"
            (ngModelChange)="changeMethod=true" (closed)="updateMethod()">
            <mat-option *ngFor="let method of methodsOptions | async" [value]="method.id">
              <span>{{method.name}}</span>
            </mat-option>
          </mat-select>
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down pointer-in"></i>
          </mat-select-trigger>
        </mat-form-field>
      </div>
    </div>
    <div class="offcanvas-footer border-0">
      <button type="button" class="btn btn-clear" (click)="clearFilters(); closeMobileFilters()">
        Limpiar
      </button>
      <button type="button" class="btn btn-primary" (click)="closeMobileFilters()">
        Ver resultados
      </button>
    </div>
  </div>

  <!-- Backdrop -->
  <div class="offcanvas-backdrop" [class.show]="showMobileFilters" (click)="closeMobileFilters()"></div>

  <div class="content-table-orders">
    <app-orders-table [activeSelectList]="activeSelectList" [selectedItems]="selectedItems" [business]="business"
      (selectedItemsChange)="selectedItemsChange($event)" [idEvent]="idEvent"
      [places]="placeFilter ? [placeFilter] : []"></app-orders-table>
  </div>
</div>
